module.exports = __webpack_public_path__ + "media/images/mapmarker-33393cc5322add5585d186020e5104d7.png";